import { Icon, type IconType } from '@graftcode/design-system'

import { TECHNOLOGY_STACK_ICON_MAP } from '@common/constants/technologyStackIcons.const'

export const QUICK_START_LANGUAGE_ICON_MAP: Record<string, IconType> = {
  ...TECHNOLOGY_STACK_ICON_MAP,
}

export function getQuickStartLanguageIcon(languageKey: string): IconType {
  return QUICK_START_LANGUAGE_ICON_MAP[languageKey.toLowerCase()] ?? Icon.DSJsColor
}
